import type { JSX } from 'react'

export const WomanAvatar = (): JSX.Element => (
  <use href='#womanAvatar' height='100%' width='100%' />
)
